/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPFREQUENCY } from './IAPFREQUENCY';
import {
    IAPFREQUENCYFromJSON,
    IAPFREQUENCYFromJSONTyped,
    IAPFREQUENCYToJSON,
} from './IAPFREQUENCY';
import type { IAPINCOMEOPTION } from './IAPINCOMEOPTION';
import {
    IAPINCOMEOPTIONFromJSON,
    IAPINCOMEOPTIONFromJSONTyped,
    IAPINCOMEOPTIONToJSON,
} from './IAPINCOMEOPTION';
import type { IAPTAXREASON } from './IAPTAXREASON';
import {
    IAPTAXREASONFromJSON,
    IAPTAXREASONFromJSONTyped,
    IAPTAXREASONToJSON,
} from './IAPTAXREASON';
import type { IAPTAXSCALE } from './IAPTAXSCALE';
import {
    IAPTAXSCALEFromJSON,
    IAPTAXSCALEFromJSONTyped,
    IAPTAXSCALEToJSON,
} from './IAPTAXSCALE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface InvestmentDetailsIncomeViewModel
 */
export interface InvestmentDetailsIncomeViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomeId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    livingAnnuityIncomeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomeTaxPercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    firstPaymentDate?: Date;
    /**
     * 
     * @type {IAPFREQUENCY}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    frequency?: IAPFREQUENCY;
    /**
     * 
     * @type {IAPINCOMEOPTION}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomeOption?: IAPINCOMEOPTION;
    /**
     * 
     * @type {IAPTAXSCALE}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    incomeTax?: IAPTAXSCALE;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    taxRate?: number;
    /**
     * 
     * @type {IAPTAXREASON}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    taxReasonId?: IAPTAXREASON;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    growthRatePercentage?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsIncomeViewModel
     */
    hasGrowthRate?: IAPYESORNO;
}

/**
 * Check if a given object implements the InvestmentDetailsIncomeViewModel interface.
 */
export function instanceOfInvestmentDetailsIncomeViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentDetailsIncomeViewModelFromJSON(json: any): InvestmentDetailsIncomeViewModel {
    return InvestmentDetailsIncomeViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsIncomeViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsIncomeViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incomeId': !exists(json, 'IncomeId') ? undefined : json['IncomeId'],
        'incomeAmount': !exists(json, 'IncomeAmount') ? undefined : json['IncomeAmount'],
        'livingAnnuityIncomeAmount': !exists(json, 'LivingAnnuityIncomeAmount') ? undefined : json['LivingAnnuityIncomeAmount'],
        'incomePercentage': !exists(json, 'IncomePercentage') ? undefined : json['IncomePercentage'],
        'incomeTaxPercentage': !exists(json, 'IncomeTaxPercentage') ? undefined : json['IncomeTaxPercentage'],
        'firstPaymentDate': !exists(json, 'FirstPaymentDate') ? undefined : (new Date(json['FirstPaymentDate'])),
        'frequency': !exists(json, 'Frequency') ? undefined : IAPFREQUENCYFromJSON(json['Frequency']),
        'incomeOption': !exists(json, 'IncomeOption') ? undefined : IAPINCOMEOPTIONFromJSON(json['IncomeOption']),
        'incomeTax': !exists(json, 'IncomeTax') ? undefined : IAPTAXSCALEFromJSON(json['IncomeTax']),
        'taxRate': !exists(json, 'TaxRate') ? undefined : json['TaxRate'],
        'taxReasonId': !exists(json, 'TaxReasonId') ? undefined : IAPTAXREASONFromJSON(json['TaxReasonId']),
        'growthRatePercentage': !exists(json, 'GrowthRatePercentage') ? undefined : json['GrowthRatePercentage'],
        'hasGrowthRate': !exists(json, 'HasGrowthRate') ? undefined : IAPYESORNOFromJSON(json['HasGrowthRate']),
    };
}

export function InvestmentDetailsIncomeViewModelToJSON(value?: InvestmentDetailsIncomeViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IncomeId': value.incomeId,
        'IncomeAmount': value.incomeAmount,
        'LivingAnnuityIncomeAmount': value.livingAnnuityIncomeAmount,
        'IncomePercentage': value.incomePercentage,
        'IncomeTaxPercentage': value.incomeTaxPercentage,
        'FirstPaymentDate': value.firstPaymentDate === undefined ? undefined : (value.firstPaymentDate.toISOString()),
        'Frequency': IAPFREQUENCYToJSON(value.frequency),
        'IncomeOption': IAPINCOMEOPTIONToJSON(value.incomeOption),
        'IncomeTax': IAPTAXSCALEToJSON(value.incomeTax),
        'TaxRate': value.taxRate,
        'TaxReasonId': IAPTAXREASONToJSON(value.taxReasonId),
        'GrowthRatePercentage': value.growthRatePercentage,
        'HasGrowthRate': IAPYESORNOToJSON(value.hasGrowthRate),
    };
}

